import { render, staticRenderFns } from "./SurveyFormCreate.vue?vue&type=template&id=3d04fd9e"
import script from "./SurveyFormCreate.vue?vue&type=script&lang=ts"
export * from "./SurveyFormCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports